import React from 'react';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blogData';
export function Blog() {
  const featuredPost = BLOG_POSTS.find(post => post.featured);
  const regularPosts = BLOG_POSTS.filter(post => !post.featured);
  return <div className="min-h-screen bg-brand-light pb-20" data-id="element-483" data-mp="qybw2of0soew">
      {/* Hero Band */}
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-484" data-mp="376jci4dmc8t">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-485" data-mp="35d80pitj3uh">
          <span className="text-brand-gold font-semibold tracking-wider text-sm uppercase mb-4 block" data-id="element-486" data-mp="3uc68ts9p90yh">
            Health Insights
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-487" data-mp="86j672v8zjbe">
            Maisha Health Blog
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-488" data-mp="3gkrqlnnm93sh">
            Educational articles, clinic updates, and expert medical advice from
            our healthcare professionals.
          </p>
        </div>
      </div>

      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-489" data-mp="2746zbekfotrt">
        {/* Featured Post */}
        {featuredPost && <div className="mb-16" data-id="element-490" data-mp="2bwgnap1znjrg">
            <div className="bg-white rounded-3xl overflow-hidden shadow-soft border border-slate-100 flex flex-col lg:flex-row group cursor-pointer" data-id="element-491" data-mp="2bx9wdwof6lcr">
              <div className="w-full lg:w-1/2 h-64 lg:h-auto overflow-hidden" data-id="element-492" data-mp="1j79mtkiz4k3k">
                <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-493" data-mp="1o52uyj3u7o6h" />
              </div>
              <div className="w-full lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center" data-id="element-494" data-mp="1x7kf8rzxm6qu">
                <div className="flex items-center gap-4 mb-4" data-id="element-495" data-mp="33ltne91lpvhp">
                  <span className="bg-brand-red/10 text-brand-red text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-496" data-mp="38kmxdrhoj4d4">
                    {featuredPost.category}
                  </span>
                  <div className="flex items-center gap-1 text-slate-500 text-sm" data-id="element-497" data-mp="14id1jy5bfod3">
                    <Calendar className="w-4 h-4" data-id="element-498" data-mp="1ihw6ki2tyjl6" /> {featuredPost.date}
                  </div>
                </div>
                <h2 className="text-3xl font-heading font-bold text-brand-navy mb-4 group-hover:text-brand-red transition-colors" data-id="element-499" data-mp="1djb4se7xjrum">
                  {featuredPost.title}
                </h2>
                <p className="text-slate-600 text-lg leading-relaxed mb-8" data-id="element-500" data-mp="kudnadbjlz2x">
                  {featuredPost.excerpt}
                </p>
                <Link to={`/blog/${featuredPost.id}`} className="inline-flex items-center gap-2 text-brand-navy font-semibold hover:text-brand-red transition-colors mt-auto" data-id="element-501" data-mp="zjtaxkfs1oee">
                  Read Full Article <ArrowRight className="w-5 h-5" data-id="element-502" data-mp="23e6w0i45xl9" />
                </Link>
              </div>
            </div>
          </div>}

        {/* Grid Posts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-503" data-mp="2dod8rtrkvyvd">
          {regularPosts.map(post => <div key={post.id} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-soft-lg transition-all duration-300 border border-slate-100 group flex flex-col cursor-pointer" data-id="element-504" data-mp="24prvad0yra1g">
              <div className="h-48 overflow-hidden relative" data-id="element-505" data-mp="2wi0p195e5oac">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-506" data-mp="31fsezxmh70bw" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-brand-navy text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full shadow-sm" data-id="element-507" data-mp="2sekuqjgso00t">
                  {post.category}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-508" data-mp="1gy4a8bqdut73">
                <div className="flex items-center gap-4 mb-3 text-slate-500 text-xs font-medium" data-id="element-509" data-mp="1wavr26e6ok5x">
                  <div className="flex items-center gap-1" data-id="element-510" data-mp="1ri2mbiiptbtu">
                    <Calendar className="w-3.5 h-3.5" data-id="element-511" data-mp="1mjrflgnpvhfu" /> {post.date}
                  </div>
                  <div className="flex items-center gap-1" data-id="element-512" data-mp="1iifn93dgki3y">
                    <Clock className="w-3.5 h-3.5" data-id="element-513" data-mp="1ik0iywbie73e" /> {post.readTime}
                  </div>
                </div>
                <h3 className="text-xl font-heading font-bold text-brand-navy mb-3 group-hover:text-brand-red transition-colors line-clamp-2" data-id="element-514" data-mp="2f7wxzwrasuci">
                  {post.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-6 line-clamp-3" data-id="element-515" data-mp="2666zk6z00v58">
                  {post.excerpt}
                </p>
                <Link to={`/blog/${post.id}`} className="inline-flex items-center gap-2 text-brand-navy font-semibold hover:text-brand-red transition-colors mt-auto text-sm" data-id="element-516" data-mp="usldiuofr9nx">
                  Read More <ArrowRight className="w-4 h-4" data-id="element-517" data-mp="31iespmwobs8w" />
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}